import useSWR from "swr";
import { AiccSandboxRender } from "types/model/aiccPromptSandbox";
import { AiccSandboxRenderRequest } from "types/dto/request/aiccPromptSandbox";
import * as sandboxAPI from "services/aiccPromptSandbox";
import { AICC_SWR_CONFIG } from "./swrConfig";

export function useAiccSandboxRender(languageId: number | undefined, payload?: AiccSandboxRenderRequest) {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    languageId && payload ? ["aicc/sandbox-render", languageId, payload] : null,
    () => sandboxAPI.renderAiccSandbox(languageId as number, payload as AiccSandboxRenderRequest),
    AICC_SWR_CONFIG
  );

  return {
    render: data as AiccSandboxRender | undefined,
    isLoading: isLoading || isValidating,
    isError: !!error,
    mutate,
  };
}
